import { createNullableContext } from '~/common/contexts/nullableContext';
import { AdminApplicationContextValue } from './types/AdminApplicationContextValue';

export const AdminApplicationContext =
  createNullableContext<AdminApplicationContextValue>();
